import { TranslateModule } from '../../../../shared/translate/translate.module';
import { AllergyAddComponent } from './allergy-add.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule, TranslateModule],
    exports: [AllergyAddComponent],
    declarations: [AllergyAddComponent],
    providers: [],
})
export class AllergyAddModule { }
